<template>
  <div class="member-rule-management">
    <div class="page-header">
      <h2>会员卡项规则</h2>
      <p>集中维护门店充值档、免费领卡、价目表和会员说明</p>
    </div>

    <div class="page-content">
      <div class="store-list-panel">
        <div class="panel-header">
          <h3>门店</h3>
          <button class="text-btn" @click="loadStoreList">刷新</button>
        </div>
        <div v-if="storeLoading" class="empty-state">加载中...</div>
        <button
          v-for="store in storeList"
          v-else
          :key="store.id"
          :class="['store-item', selectedStore && selectedStore.id === store.id ? 'active' : '']"
          @click="selectStore(store)"
        >
          <strong>{{ store.storeName }}</strong>
          <span class="store-code" :title="store.storeCode || '-'">{{ store.storeCode || '-' }}</span>
        </button>
      </div>

      <div class="rule-panel">
        <div v-if="!selectedStore" class="empty-state">请选择左侧门店后维护会员规则</div>
        <form v-else class="rule-form" @submit.prevent="saveRules">
          <div class="form-header">
            <div>
              <h3>{{ selectedStore.storeName }}</h3>
              <p>这些配置会被小程序和收银端共同读取</p>
            </div>
            <button type="submit" class="save-btn" :disabled="saving">{{ saving ? '保存中...' : '保存规则' }}</button>
          </div>

          <div class="form-grid">
            <div class="form-group">
              <label>充值档位</label>
              <textarea v-model="ruleForm.rechargeAmountOptions" class="form-textarea" placeholder="例如：100,200,500"></textarea>
            </div>
            <div class="form-group">
              <label>充值档详情</label>
              <textarea v-model="ruleForm.rechargeOptionDetails" class="form-textarea" placeholder="例如：充 100 送 10，充 500 送 80"></textarea>
            </div>
            <div class="form-group">
              <label>价目表</label>
              <textarea v-model="ruleForm.priceInfo" class="form-textarea" placeholder="填写门店服务价目"></textarea>
            </div>
            <div class="form-group">
              <label>时长金额规则</label>
              <textarea v-model="ruleForm.durationAmountRules" class="form-textarea" placeholder="例如：30分钟=10元，60分钟=18元"></textarea>
            </div>
            <div class="form-group">
              <label>会员充值说明</label>
              <textarea v-model="ruleForm.rechargeDiscountInformation" class="form-textarea" placeholder="展示给顾客的充值优惠说明"></textarea>
            </div>
            <div class="form-group">
              <label>上机须知</label>
              <textarea v-model="ruleForm.playNotice" class="form-textarea" placeholder="展示给顾客的使用须知"></textarea>
            </div>
          </div>

          <div class="switch-grid">
            <label class="switch-item">
              <input v-model="ruleForm.allowCustomRecharge" type="checkbox" />
              <span>允许自定义充值金额</span>
            </label>
            <label class="switch-item">
              <input v-model="ruleForm.allowFreeCard" type="checkbox" />
              <span>允许微信授权免费领卡</span>
            </label>
          </div>

          <div class="number-grid">
            <div class="form-group">
              <label>免费领卡余额</label>
              <input v-model.number="ruleForm.freeCardBalance" type="number" min="0" step="0.01" class="form-input" />
            </div>
            <div class="form-group">
              <label>免费领卡积分</label>
              <input v-model.number="ruleForm.freeCardPoints" type="number" min="0" step="1" class="form-input" />
            </div>
            <div class="form-group">
              <label>延迟开机分钟</label>
              <input v-model.number="ruleForm.delayedStartMinutes" type="number" min="0" step="1" class="form-input" />
            </div>
            <div class="form-group">
              <label>下机提醒分钟</label>
              <input v-model.number="ruleForm.downDeviceTipMinutes" type="number" min="1" step="1" class="form-input" />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../utils/request'

export default {
  name: 'MemberRuleManagement',
  data() {
    return {
      storeList: [],
      selectedStore: null,
      ruleForm: {},
      storeLoading: false,
      saving: false
    }
  },
  mounted() {
    this.loadStoreList()
  },
  methods: {
    async loadStoreList() {
      this.storeLoading = true
      try {
        const response = await request.get('/api/stores/getStores', { params: { page: 0, size: 1000 } })
        if (response.data.success && response.data.code === 200) {
          this.storeList = response.data.data.content || []
          if (!this.selectedStore && this.storeList.length) {
            this.selectStore(this.storeList[0])
          }
        }
      } finally {
        this.storeLoading = false
      }
    },
    selectStore(store) {
      this.selectedStore = store
      this.ruleForm = {
        rechargeAmountOptions: store.rechargeAmountOptions || '',
        rechargeOptionDetails: store.rechargeOptionDetails || '',
        priceInfo: store.priceInfo || '',
        durationAmountRules: store.durationAmountRules || '',
        rechargeDiscountInformation: store.rechargeDiscountInformation || '',
        playNotice: store.playNotice || '',
        allowCustomRecharge: !!store.allowCustomRecharge,
        allowFreeCard: !!store.allowFreeCard,
        freeCardBalance: Number(store.freeCardBalance || 0),
        freeCardPoints: Number(store.freeCardPoints || 0),
        delayedStartMinutes: Number(store.delayedStartMinutes || 0),
        downDeviceTip: store.downDeviceTip === undefined ? 0 : Number(store.downDeviceTip),
        downDeviceTipMinutes: Number(store.downDeviceTipMinutes || 5)
      }
    },
    async saveRules() {
      if (!this.selectedStore) return
      this.saving = true
      try {
        const payload = {
          ...this.selectedStore,
          ...this.ruleForm,
          adminIdList: this.selectedStore.adminIdList || []
        }
        const response = await request.post('/api/stores/updateStore', payload)
        if (response.data.success && response.data.code === 200) {
          Object.assign(this.selectedStore, this.ruleForm)
          alert('会员规则已保存')
        } else {
          throw new Error(response.data.message || '保存失败')
        }
      } catch (error) {
        alert(error.message || '保存失败')
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.page-header { margin-bottom: 24px; }
.page-header h2 { margin: 0 0 8px; color: #333; }
.page-header p { margin: 0; color: #666; }
.page-content { display: grid; grid-template-columns: 280px 1fr; gap: 20px; }
.store-list-panel, .rule-panel { background: #fff; border-radius: 8px; padding: 20px; }
.panel-header, .form-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; }
.panel-header h3, .form-header h3 { margin: 0; }
.form-header p { margin: 6px 0 0; color: #666; }
.text-btn { background: transparent; border: none; color: #1890ff; cursor: pointer; }
.store-item { display: block; width: 100%; min-width: 0; margin-bottom: 10px; padding: 12px; text-align: left; background: #f7f8fa; border: 1px solid transparent; border-radius: 6px; cursor: pointer; overflow: hidden; }
.store-item strong, .store-item span { display: block; min-width: 0; }
.store-item strong { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.store-item span { margin-top: 4px; color: #999; }
.store-code { max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 12px; }
.store-item.active { border-color: #1890ff; background: #e6f7ff; }
.empty-state { padding: 40px; text-align: center; color: #999; }
.form-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px; }
.form-group label { display: block; margin-bottom: 8px; color: #333; }
.form-textarea { width: 100%; min-height: 96px; padding: 10px 12px; border: 1px solid #d9d9d9; border-radius: 6px; resize: vertical; }
.form-input { width: 100%; height: 36px; padding: 0 12px; border: 1px solid #d9d9d9; border-radius: 6px; }
.switch-grid, .number-grid { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 16px; margin-top: 16px; }
.switch-item { padding: 12px; background: #f7f8fa; border-radius: 6px; }
.save-btn { border: none; border-radius: 6px; padding: 8px 16px; background: #1890ff; color: #fff; cursor: pointer; }
@media (max-width: 1100px) {
  .page-content { grid-template-columns: 1fr; }
  .form-grid, .switch-grid, .number-grid { grid-template-columns: 1fr; }
}
</style>
